import type { WithActiveBranchId } from '@app/api/shared';

export enum MoneyExpensesEndpoints {
  AddMoneyExpense = 'AddMoneyExpense',
  DeleteMoneyExpense = 'DeleteMoneyExpense',
  GetFile = 'GetFile',
}

export interface ModelMoneyExpense {
  Id: number;
  Timestamp: string;
  TimeCreated: string | null;
  UserId: number;
  User: string | null;
  PaymentAccountId: number;
  PaymentAccount: string | null;
  ExpenseArticleId: number;
  ExpenseArticle: string | null;
  Amount: number;
  Comment: string | null;
}

export interface ModelMoneyExpensesFile {
  Id: number;
  Name: string | null;
  Data: string | null;
  Lifetime: string | null;
  Description: string | null;
}

export interface AddMoneyExpenseRequest extends WithActiveBranchId {
  data: FormData;
  Id?: number;
  Timestamp?: string;
  TimeCreated?: string | null;
  UserId?: number;
  User?: string | null;
  PaymentAccountId?: number;
  PaymentAccount?: string | null;
  ExpenseArticleId?: number;
  ExpenseArticle?: string | null;
  Amount?: number;
  Comment?: string | null;
}

export interface DeleteMoneyExpenseRequest extends WithActiveBranchId {
  moneyExpenseId?: number;
}

export interface GetFileRequest extends WithActiveBranchId {
  fileId: number;
}

export type AddMoneyExpenseResponse = ModelMoneyExpense;
export type DeleteMoneyExpenseResponse = void;
export type GetFileResponse = ModelMoneyExpensesFile;
